import { useEffect } from "preact/hooks";
import { signal, computed } from "@preact/signals";
import { HomePage } from "./pages/HomePage";
import { PairingPageDev } from "./pages/PairingPageDev";
import { tokenStore } from "./storage/tokens";

// 极简 hash router：dev 阶段只两个页面
//   #/         → HomePage（要求已配对）
//   #/pair-dev → 开发模式手填配对
const route = signal<string>(window.location.hash.slice(1) || "/");
window.addEventListener("hashchange", () => {
  route.value = window.location.hash.slice(1) || "/";
});

// 用 hasIdentity 判断要不要强制跳到配对页
const hasIdentity = signal<boolean>(false);

const currentPage = computed(() => {
  if (route.value === "/pair-dev") return "pair-dev";
  if (!hasIdentity.value) return "pair-dev"; // 没配对 → 强制配对
  return "home";
});

export function App() {
  useEffect(() => {
    void (async () => {
      const ident = await tokenStore.getIdentity();
      hasIdentity.value = !!ident;
    })();
  }, []);

  return (
    <div class="app-root">
      {currentPage.value === "home" ? (
        <HomePage onLogout={async () => {
          await tokenStore.clear();
          hasIdentity.value = false;
          window.location.hash = "#/pair-dev";
        }} />
      ) : (
        <PairingPageDev onPaired={() => {
          hasIdentity.value = true;
          window.location.hash = "#/";
        }} />
      )}
    </div>
  );
}
